import React, { ReactNode, HTMLProps, forwardRef } from 'react'
import classnames from 'classnames'
import { makeStyles, createStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'

export interface IPillProps extends Omit<HTMLProps<HTMLButtonElement>, 'type'> {
  children: ReactNode
  facet?: boolean
  applied?: boolean
}

const usePillStyles = makeStyles(() =>
  createStyles<string, Omit<IPillProps, 'children' | 'className'>>({
    pill: ({ applied, facet }) => ({
      backgroundColor: brandColors.white,
      border: `1px solid $${brandColors.coolGray4}`,
      borderRadius: 35,
      boxShadow: 'none',
      lineHeight: 0,
      padding: '5px 12px',
      width: 'auto',
      minHeight: 33,
      '&:hover': {
        backgroundColor: brandColors.coolGray1,
      },
      '&:active, &:focus': {
        '&:hover': {
          backgroundColor: brandColors.coolGray1,
        },
        backgroundColor: brandColors.white,
        borderColor: brandColors.coolGray4,
      },
      borderColor: applied ? brandColors.skyBlue6 : brandColors.coolGray4,
      color: applied ? brandColors.skyBlue6 : brandColors.black,
      'svg path': {
        color: applied && facet ? brandColors.skyBlue7 : 'auto',
      },
    }),
  })
)

export const Pill = forwardRef<HTMLButtonElement, IPillProps>(
  ({ children, className, ...props }, ref) => {
    const styles = usePillStyles(props)
    const containerClasses = classnames(styles.pill, className)

    return (
      <button className={containerClasses} type='button' {...props} ref={ref}>
        {children}
      </button>
    )
  }
)

export default Pill
